import { PriceDTO, StockDTO, GroupUserLinksFields, Group, ProductFullSolrDTO, FavoritesDTO} from "@signature-it/ngx-catalogue/models";
import { createAction, props} from "@ngrx/store";

export const GET_PRODUCT_PRICE = '[Catalogue] GET_PRODUCT_PRICE';
export const GOT_PRODUCT_PRICE_SUCCESS = '[Catalogue] GOT_PRODUCT_PRICE_SUCCESS';
export const GOT_PRODUCT_PRICE_FAILURE = '[Catalogue] GOT_PRODUCT_PRICE_FAILURE';
export const GET_PRODUCTS_STOCK = '[Catalogue] GET_PRODUCTS_STOCK';
export const GOT_PRODUCTS_STOCK_SUCCESS = '[Catalogue] GOT_PRODUCTS_STOCK_SUCCESS';
export const GOT_PRODUCTS_STOCK_FAILURE = '[Catalogue] GOT_PRODUCTS_STOCK_FAILURE';
export const GET_GROUP_USER_LINKS = '[Catalogue] GET_GROUP_USER_LINKS';
export const GOT_GROUP_USER_LINKS_SUCCESS = '[Catalogue] GOT_GROUP_USER_LINKS_SUCCESS';
export const GOT_GROUP_USER_LINKS_FAILURE = '[Catalogue] GOT_GROUP_USER_LINKS_FAILURE';
export const GET_GROUPS_TREE = '[Catalogue] GET_GROUPS_TREE';
export const GOT_GROUPS_TREE_SUCCESS = '[Catalogue] GOT_GROUPS_TREE_SUCCESS';
export const GOT_GROUPS_TREE_FAILURE = '[Catalogue] GOT_GROUPS_TREE_FAILURE';
export const GET_CURRENT_GROUP = '[Catalogue] GET_CURRENT_GROUP';
export const GOT_CURRENT_GROUP_SUCCESS = '[Catalogue] GOT_CURRENT_GROUP_SUCCESS';
export const GOT_CURRENT_GROUP_FAILURE = '[Catalogue] GOT_CURRENT_GROUP_FAILURE';
export const GET_PRODUCT_SOLR_DOC = '[Catalogue] GET_PRODUCT_SOLR_DOC';
export const GOT_PRODUCT_SOLR_DOC_SUCCESS = '[Catalogue] GOT_PRODUCT_SOLR_DOC_SUCCESS';
export const GOT_PRODUCT_SOLR_DOC_FAILURE = '[Catalogue] GOT_PRODUCT_SOLR_DOC_FAILURE';
export const GET_FAVORITES = '[Catalogue] GET_FAVORITES';
export const GET_FAVORITES_SUCCESS = '[Catalogue] GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_FAILURE = '[Catalogue] GET_FAVORITES_FAILURE';
export const ADD_FAVORITE = '[Catalogue] ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = '[Catalogue] ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_FAILURE = '[Catalogue] ADD_FAVORITE_FAILURE';
export const REMOVE_FAVORITE = '[Catalogue] REMOVE_FAVORITE';
export const REMOVE_FAVORITE_SUCCESS = '[Catalogue] REMOVE_FAVORITE_SUCCESS';
export const REMOVE_FAVORITE_FAILURE = '[Catalogue] REMOVE_FAVORITE_FAILURE';

export const getProductPrice = createAction(GET_PRODUCT_PRICE,(payload: Array<number>) => {return {payload}});
export const gotProductPriceSuccess = createAction(GOT_PRODUCT_PRICE_SUCCESS, (payload: PriceDTO[]) => {return {prices: payload}});
export const gotProductPriceFailure = createAction(GOT_PRODUCT_PRICE_FAILURE);
export const getProductsStock = createAction(GET_PRODUCTS_STOCK, (payload: Array<any>) => {return {payload}});
export const gotProductsStockSuccess = createAction(GOT_PRODUCTS_STOCK_SUCCESS, (payload: StockDTO[]) => {return {stock: payload}});
export const gotProductsStockFailure = createAction(GOT_PRODUCTS_STOCK_FAILURE);
export const getGroupUserLinks = createAction(GET_GROUP_USER_LINKS, (groupId: number, taxonomy?, entityVar?) => {return {payload: { groupId, taxonomy, entityVar}}});
export const gotGroupUserLinksSuccess = createAction(GOT_GROUP_USER_LINKS_SUCCESS, (payload: GroupUserLinksFields[]) => {
        return {
            payload
        };
    });
export const gotGroupUserLinksFailure = createAction(GOT_GROUP_USER_LINKS_FAILURE);
export const getGroupsTree = createAction(GET_GROUPS_TREE, (taxonomy) => {return {payload: taxonomy}});
export const gotGroupsTreeSuccess = createAction(GOT_GROUPS_TREE_SUCCESS, (groupTree: Group) => {
    return {
        payload: groupTree
    }
});
export const gotGroupsTreeFailure = createAction(GOT_GROUP_USER_LINKS_FAILURE);
export const getCurrentGroup = createAction(GET_CURRENT_GROUP, (groupId, getAdditionalData) => {
    return {payload: {groupId, getAdditionalData}}
});
export const gotCurrentGroupSuccess = createAction(GOT_CURRENT_GROUP_SUCCESS, (group: Group) => {
    return  {payload: group}
});
export const gotCurrentGroupFailure = createAction(GOT_CURRENT_GROUP_FAILURE);
export const getProductSolrDoc = createAction(GET_PRODUCT_SOLR_DOC, (payload: any) => { return {payload}});
export const gotProductSolrDocSuccess = createAction(GOT_PRODUCT_SOLR_DOC_SUCCESS, (payload: ProductFullSolrDTO) => payload);
export const gotProductSolrDocFailure = createAction(GOT_PRODUCT_SOLR_DOC_FAILURE);
export const getFavorites = createAction(GET_FAVORITES);
export const getFavoritesSuccess = createAction(GET_FAVORITES_SUCCESS, (payload: FavoritesDTO[]) => {
    return  {payload}
});
export const getFavoritesFailure = createAction(GET_FAVORITES_FAILURE);
export const addFavorite = createAction(ADD_FAVORITE, (payload: any) => { return {payload}});
export const addFavoriteSuccess = createAction(ADD_FAVORITE_SUCCESS, (payload: any) => payload);
export const addFavoriteFailure = createAction(ADD_FAVORITE_FAILURE);
export const removeFavorite = createAction(REMOVE_FAVORITE, (payload: any) => { return {payload}});
export const removeFavoriteSuccess = createAction(REMOVE_FAVORITE_SUCCESS, (payload: any) => payload);
export const removeFavoriteFailure = createAction(REMOVE_FAVORITE_FAILURE);
